<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Vendor'" [binding]="'vendor'" [dataMap]="vendorMap" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Type of Pipe'" [binding]="'typeOfPipe'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Process for Pipe'" [binding]="'processForPipe'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Minimum Bedding'" [binding]="'minimumBedding'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Minimum Bedding Width'"
                        [binding]="'minimumBeddingWidth'"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Minimum Above Pipe'" [binding]="'minimumAbovePipe'" [width]="140"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Bedding Material'" [binding]="'beddingMaterial'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Bedding Required Compaction'"
                        [binding]="'beddingRequiredCompaction'"
                        [width]="180"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Trench Zone Backfill Material'"
                        [binding]="'trenchZoneBackfillMaterial'"
                        [width]="180"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Trench Zone Max Lift'"
                        [binding]="'trenchZoneMaxLift'"
                        [width]="140"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Trench Zone Required Compaction'"
                        [binding]="'trenchZoneRequiredCompaction'"
                        [width]="200"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Trench Zone Optimum Moisture'"
                        [binding]="'trenchZoneOptimumMoisture'"
                        [width]="180"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Trench Zone Product'"
                        [binding]="'trenchZoneProduct'"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Trench Zone Vendor'"
                        [binding]="'trenchZoneVendorId'"
                        [dataMap]="trenchZoneVendorMap"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Location to be Installed'"
                        [binding]="'locationToBeInstalled'"
                        [width]="180"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
